import React, { FC } from 'react';

import { cn } from '../lib/utils';
import { UIRadioGroup } from '../ui';

import RadioButton, { RadioButtonOptionsProps } from './RadioButton';

type RadioButtonGroupProps = React.ComponentProps<typeof UIRadioGroup> & {
  dataTestId?: string;
  value?: string;
  onValueChange?: (value: string) => void;
  className?: string;
  itemClassName?: string;
  options?: RadioButtonOptionsProps[];
  isColumn?: boolean;
  selectedColor?: string;
};

const RadioButtonGroup: FC<RadioButtonGroupProps> = ({
  dataTestId,
  value = '',
  onValueChange,
  className,
  itemClassName,
  options = [],
  isColumn = false,
  selectedColor
}) => {
  const columnGroupClasses = isColumn && 'gap-2 flex-col';

  return (
    <UIRadioGroup
      value={value}
      onValueChange={onValueChange}
      className={cn('flex gap-[19px]', columnGroupClasses, className)}
      data-testid={dataTestId}
    >
      {options.length > 0 &&
        options.map((option, index) => (
          <RadioButton
            className={itemClassName}
            key={index}
            selectedColor={selectedColor}
            {...option}
            {...(dataTestId && { dataTestId: `${dataTestId}-${option.value}` })}
          />
        ))}
    </UIRadioGroup>
  );
};

export default RadioButtonGroup;
